import { createContext, useContext } from 'react';

export interface Confirmation {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
}
export const ConfirmContext = createContext<((options: Confirmation) => Promise<boolean>) | null>(
  null,
);
export function useConfirm(): (options: Confirmation) => Promise<boolean> {
  const confirm = useContext(ConfirmContext);
  if (!confirm) throw new Error('ConfirmProvider required');
  return confirm;
}
